export enum FeeCalculatorFieldType {
  Numeric = "Numeric",
  Currency = "Currency",
  Checkbox = "Checkbox",
  Toggle = "Toggle",
}
